import { render, staticRenderFns } from "./OAuthConsent.vue?vue&type=template&id=154e2956"
import script from "./OAuthConsent.vue?vue&type=script&lang=js"
export * from "./OAuthConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports